
import React, { useState, useEffect } from 'react';

import throttle from 'lodash.throttle';
import ProductSlider from '../SliderLib/ProductSlider/components/ProductSlider';
import TopStories from './HeroBanner/TopStories';
import SliderStories from './HeroBanner/SliderStories';

// import dataMock from './dataMock';
import './indexBanners.less';

const bannersData = window.__INITIAL_STATE__;
// const bannersData = dataMock;
const HeroBanner = () => {
  const [isDesktop, setDescktop] = useState(window.innerWidth >= 1024);
  const [isMobile, setMobile] = useState(window.innerWidth < 1024);
  const handleWindowResize = throttle(() => {
    setMobile(window.innerWidth < 1024);
    setDescktop(window.innerWidth >= 1024);
  }, 1000);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <div>
      <div className="mainWidth">
        {bannersData.map((banner) => {
          if (banner.online) {
            if (isDesktop && (banner.order_index === 1 || banner.order_index === 2)) {
              return <TopStories key={banner.order_index} banner={banner} isMobile={isMobile} />;
            }
            if (isMobile && banner.order_index === 1) {
              return <TopStories key={banner.order_index} banner={banner} isMobile={isMobile} />;
            }
            return null;
          }
          return null;
        })}
      </div>
      <ProductSlider>
        {bannersData.map((banner) => {
          if (banner.online) {
            if (isMobile && banner.order_index > 1) {
              return (
                <SliderStories
                  key={banner.order_index}
                  banner={banner}
                  isMobile={isMobile}
                  isDesktop={isDesktop}
                />);
            }
            if (isDesktop && banner.order_index > 2) {
              return (
              <SliderStories
                key={banner.order_index}
                banner={banner}
                isMobile={isMobile}
                isDesktop={isDesktop}
              />);
            }
            return null;
          }
          return null;
        })}
      </ProductSlider>
    </div>
  );
};

export default HeroBanner;
